import { html } from "lit";
var icon_learn_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      fill-rule="evenodd"
      d="M6 16.108l2 1v5.79c0 .352.186.679.49.86C11.013 25.257 13.513 26 16 26c2.486 0 4.986-.743 7.51-2.243a.996.996 0 00.481-.729l.009-.13v-5.661l2-1v6.66a3.001 3.001 0 01-1.468 2.58C21.71 27.153 18.862 28 16 28c-2.861 0-5.71-.846-8.532-2.524a3 3 0 01-1.462-2.381L6 22.897v-6.79zM16 3l16.629 7.622L16 18.936-.629 10.622 16 3zm0 2.2L4 10.7l12 6 12-6-12-5.5z" />
  </svg>
`;
export {
  icon_learn_default as default
};
//# sourceMappingURL=icon-learn.js.map
